import { render } from "./ExportBtns.vue?vue&type=template&id=036f861c"
import script from "./ExportBtns.vue?vue&type=script&lang=js"
export * from "./ExportBtns.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__